import styled from 'styled-components';
import { GatsbyImage } from 'gatsby-plugin-image';
import { colors, mediaQueries, size, typography } from '@everlywell/leaves';

export const Headline = styled.h2`
  ${typography.h3Text};
  font-weight: ${typography.weight.book};
  font-size: 25px;
  margin-bottom: ${size.xl1}px;
  line-height: 32px;
  letter-spacing: 0.53px;

  ${mediaQueries.forTabletVerticalUp} {
    font-weight: ${typography.weight.book};
    margin-bottom: ${size.xl4}px;
    font-size: 41px;
    line-height: 56px;
    letter-spacing: 0.1px;
  }

  ${mediaQueries.forTabletHorizontalUp} {
    font-weight: ${typography.weight.book};
  }
`;

export const Step = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 100%;
  position: relative;

  ${mediaQueries.forTabletHorizontalUp} {
    flex-direction: column;
    align-items: center;
  }
`;

export const Text = styled.p`
  ${typography.bodyTextSmall};
  line-height: 24px;
  color: #2d2d2d;
  font-size: 14px;
  margin-top: 10px;

  ${mediaQueries.forTabletHorizontalUp} {
    font-size: 18px;
    line-height: 29px;
    margin-top: 0;
  }
`;

export const Image = styled(GatsbyImage)`
  max-width: 60px;
  max-height: 60px;
  min-width: 60px;
  min-height: 60px;
  /* we are declaring the same min and max width instead of just width to fix a bug on safari mobile  */
  margin-right: 31px;
  margin-bottom: ${size.xl2}px;

  ${mediaQueries.forTabletHorizontalUp} {
    max-width: 120px;
    max-height: 120px;
    margin-bottom: ${size.lg}px;
    margin-right: 0;
  }
`;

export const StepsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 55px;

  ${Step} {
    &:before {
      content: '';
      width: 10px;
      height: 48px;
      position: absolute;
      bottom: 0;
      left: 25px;
      background-color: ${colors.teal4};
    }

    &:last-child {
      &:before {
        height: 0;
      }

      ${Image} {
        margin-bottom: 0;
      }
    }
  }

  ${mediaQueries.forTabletHorizontalUp} {
    flex-direction: row;
    align-items: flex-start;

    ${Step} {
      &:before {
        top: 55px;
        width: 100%;
        height: 10px;
        transform: translate(-50%, -50%);
      }

      &:first-child {
        &:before {
          height: 0;
        }
      }

      &:last-child {
        &:before {
          height: 10px;
        }
        ${Image} {
          margin-bottom: 24px;
        }
      }

      ${Text} {
        max-width: 222px;
        text-align: center;
      }
    }
  }
`;

export const Blurb = styled.div`
  margin-bottom: ${size.lg}px;
`;

export const BlurbTitle = styled.h3`
  ${typography.h4Text}

  ${mediaQueries.forTabletHorizontalUp} {
    letter-spacing: 0.5px;
  }
`;
